import React, { useEffect, useState } from 'react'
import { superAxiosRequest } from 'axiosApi'
import asideModalStore from 'Stores/asideModalStore'
import swal from 'sweetalert'
import st from './Grades.module.scss'
import PageHeader from 'components/UI/PageHeader/PageHeader'
import { HeaderAddButton } from 'components/UI/SuperButton/SuperButton'
import Pagination from 'components/UI/Pagination/Pagination'
import Loader from 'components/UI/Loader/Loader'
import AddGradeModal from './AddGradeModal/AddGradeModal'
import RowGrade from './RowGrade/RowGrade'
import useLocalization from 'hooks/useLocalization'

const initPagination = {
  page: 1,
  limit: 10,
}

const Grades = () => {
  const [grades, setGrades] = useState(null)
  const [loading, setLoading] = useState(false)
  const [pagination, setPagination] = useState(initPagination)

  const { translate } = useLocalization({
    section: 'groups',
    subsection: 'group_setting',
    dict: {
      ratings: 'Ratings',
      add_rating: 'Add rating',
      entries: 'Entries ',
      edit: 'Edit',
      name: 'Name',
      cancel: 'Cancel',
      save: 'Save',
      delete: 'Delete',
      number: 'Serial number',
    },
  })

  const fetchGrades = () => {
    superAxiosRequest({
      method: 'get',
      link: 'progress_report/rating',
      params: {
        offset: (pagination.page - 1) * pagination.limit,
        limit: pagination.limit,
      },
    }).then(({ data }) => {
      setGrades(data)
      setLoading(false)
    })
  }

  useEffect(() => {
    setLoading(true)
    fetchGrades()
  }, [pagination])

  const onBeforeSubmitClient = (data) => {
    const { name, company, ...rest } = data
    return {
      ...rest,
      ...(name && { name: data.name }),
      ...(company && { company: data?.company }),
    }
  }

  const addGrade = () => {
    const ms = {
      modalBodyComponent: () => <AddGradeModal translate={translate} />,
      button: translate.save,
      link: 'progress_report/rating',
      title: translate.add_rating,
      isResponsive: true,
      onBeforeSubmit: onBeforeSubmitClient,
      onSubmitSuccess: () => {
        fetchGrades()
      },
      valid: {
        name: 'required',
        order: 'required',
      },
    }

    asideModalStore.activity(ms, {})
  }

  const editGrade = (data) => {
    const ms = {
      modalBodyComponent: () => <AddGradeModal translate={translate} />,
      button: translate.save,
      link: `progress_report/rating/${data?.id}`,
      title: 'Редактировать оценку',
      isResponsive: true,
      is_put: true,
      onBeforeSubmit: onBeforeSubmitClient,
      onSubmitSuccess: (data) => {
        setGrades((prev) => {
          return {
            ...prev,
            result: prev.result.map((age) =>
              age.id === data.id ? { ...age, ...data } : age,
            ),
          }
        })
      },
      valid: {
        name: 'required',
        order: 'required',
      },
    }
    asideModalStore.activity(ms, data)
  }

  const deleteGrade = (data) => {
    swal({
      title: 'Are you sure',
      text: 'Are you sure you want to delete the grade?',
      icon: 'warning',
      buttons: ['No', 'Yes'],
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        const apiConf = {
          method: 'delete',
          link: `progress_report/rating/${data?.id}`,
        }
        superAxiosRequest(apiConf).then(() => {
          setGrades((prevState) => ({
            ...prevState,
            result: prevState.result.filter((el) => el?.id !== data?.id),
          }))
        })
      }
    })
  }

  const action = (action, e, items) => {
    const actions = new Map([
      ['edit', () => editGrade(items)],
      ['delete', () => deleteGrade(items)],
    ])
    return actions.get(action)?.()
  }

  return (
    <div>
      <div className={st.header}>
        <PageHeader title={translate.ratings}>
          <HeaderAddButton title={translate.add_rating} onClick={addGrade} />
        </PageHeader>
      </div>
      {loading ? (
        <Loader />
      ) : (
        <div className={st.conteinerClient}>
          <div className={st.quantityClients}>
            {translate.entries}: {grades?._meta?.count_items}
          </div>
          <div>
            {grades?.result?.map((grade, index) => (
              <RowGrade
                key={grade.id}
                grade={grade}
                index={index}
                action={action}
                translate={translate}
              />
            ))}
          </div>
        </div>
      )}
      <div className={st.pagination}>
        {grades?._meta.count_items > 10 && (
          <Pagination
            limit={pagination.limit}
            count={grades._meta.count_items || 0}
            page={pagination.page}
            onChange={(page) => setPagination({ ...pagination, page })}
            onChangePerPage={(limit) => {
              setPagination({ page: 1, limit })
            }}
          />
        )}
      </div>
    </div>
  )
}

export default Grades
